var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12 18.5c-3.62 0-6.93-1.73-9.94-5.19a2 2 0 0 1 0-2.62C5.06 7.23 8.38 5.5 12 5.5c3.62 0 6.93 1.73 9.94 5.19a2 2 0 0 1 0 2.62c-3 3.46-6.32 5.19-9.94 5.19zm0-1.5c3.15 0 6.07-1.52 8.8-4.67a.5.5 0 0 0 0-.66C18.07 8.52 15.15 7 12 7c-3.15 0-6.07 1.52-8.8 4.67a.5.5 0 0 0 0 .66C5.93 15.48 8.85 17 12 17zm0-1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm.5-4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.88c10e3fe80731d251722fab319d1e2c.svg";
export { ForwardRef as ReactComponent };